var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhoeverIsAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21279 13.7773C2.21279 7.73128 7.11409 2.82998 13.1602 2.82998C19.2062 2.82998 24.1075 7.73128 24.1075 13.7773C24.1075 16.2027 23.3188 18.4439 21.9838 20.2584C21.9046 18.4297 20.4272 16.7704 18.349 16.7704H8.36117C6.14743 16.7704 4.54153 18.66 4.67608 20.6964C3.1363 18.8105 2.21279 16.4018 2.21279 13.7773ZM13.1602 0.777344C5.98045 0.777344 0.160156 6.59764 0.160156 13.7773C0.160156 20.957 5.98045 26.7773 13.1602 26.7773C20.3399 26.7773 26.1602 20.957 26.1602 13.7773C26.1602 6.59764 20.3399 0.777344 13.1602 0.777344ZM17.6528 10.7832C17.6528 13.263 15.6425 15.2733 13.1627 15.2733C10.6829 15.2733 8.67256 13.263 8.67256 10.7832C8.67256 8.30334 10.6829 6.29304 13.1627 6.29304C15.6425 6.29304 17.6528 8.30334 17.6528 10.7832Z",
    fill: "#404791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoeverIsAvailable);
export default __webpack_public_path__ + "static/media/whoever-is-available.5828fd2e4d5367b8d46cf4a3c613e31d.svg";
export { ForwardRef as ReactComponent };